import { motion } from "framer-motion";
import { PageHero } from "@/components/shared/PageHero";
import { Eyebrow } from "@/components/shared/Eyebrow";
import { Reveal } from "@/components/shared/Reveal";
import { DynIcon } from "@/components/shared/DynIcon";
import { CTA } from "@/components/home/CTA";
import { useSolutions } from "@/hooks/useContent";
import { useSeo } from "@/components/shared/useSeo";

const HERO = "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Cozumler() {
  const { data: solutions = [] } = useSolutions();
  useSeo({
    title: "Çözümler | Sistem Elektrik ve Mühendislik",
    description: "PLC, HMI, SCADA, proses ve makine otomasyonu, motor & sürücü sistemleri, enerji yönetimi ve endüstriyel kontrol çözümleri.",
    canonical: "https://sistemmuhendislik.com/cozumler",
  });

  return (
    <>
      <PageHero
        eyebrow="ÇÖZÜMLER"
        title="Otomasyon ve kontrol çözümleri."
        subtitle="Üretiminizi izlenebilir, verimli ve güvenilir kılan teknoloji çözümleri."
        image={HERO}
        crumb={[{ label: "Çözümler" }]}
      />

      <section className="bg-light py-20 md:py-24">
        <div className="mx-auto max-w-[1400px] px-5 md:px-8">
          <Eyebrow className="mb-6">YETKİNLİK ALANLARI</Eyebrow>
          <Reveal>
            <h2 className="font-head font-extrabold text-ink tracking-tight text-4xl md:text-5xl max-w-2xl leading-[1.05]">
              Uçtan uca otomasyon mimarisi.
            </h2>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
            {solutions.map((s, i) => (
              <motion.div
                key={s.id || i}
                data-testid={`cozum-${i}`}
                className="group relative bg-white p-7 md:p-8 hover:bg-navy transition-colors duration-500 overflow-hidden"
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (i % 4) * 0.05, duration: 0.45 }}
              >
                <span className="absolute top-5 right-5 font-head font-bold text-xs tabular-nums text-ink/20 group-hover:text-cyan/70 transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="w-12 h-12 flex items-center justify-center border border-ink/15 text-tech group-hover:border-cyan group-hover:text-cyan transition-colors duration-500">
                  <DynIcon name={s.icon} className="w-6 h-6" />
                </div>
                <h3 className="font-head font-bold text-lg mt-6 text-ink group-hover:text-white transition-colors duration-500">{s.title}</h3>
                <p className="mt-3 text-ink/55 group-hover:text-silver/70 text-sm leading-relaxed transition-colors duration-500">{s.description}</p>
                <span className="mt-5 block h-px w-0 group-hover:w-10 bg-cyan transition-all duration-500" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}
